import { render, staticRenderFns } from "./MainFrame.vue?vue&type=template&id=6ffbdb5d"
import script from "./MainFrame.vue?vue&type=script&lang=js"
export * from "./MainFrame.vue?vue&type=script&lang=js"
import style0 from "./MainFrame.vue?vue&type=style&index=0&id=6ffbdb5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports